var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"foot"}},[_c('div',{staticClass:"foot"},[_c('div',{staticClass:"foot_text"},[_vm._v(" "+_vm._s(_vm.$t("m.footText"))),_c('a',{staticStyle:{"color":"#777777","font-size":"14px"},attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("m.record")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }